<template>
    <!-- 合同外线路成本弹框 -->
    <el-dialog
        v-dialogDrag
        class="dispatchOrder_contractDialog"
        :closeOnClickModal='false'
        :before-close="beforeClose"
        title="合同外线路成本"
        :visible="true"
        width="27%">
        <el-form
            :model="model"
            :rules="rules"
            label-width="120px"
            ref="elForm"
            >
            <el-form-item
                label="运输成本(元)"
                prop="transportationCost">
                <el-input
                    clearable
                    v-model.trim="model.transportationCost"
                    size="medium"
                ></el-input>
            </el-form-item>
            <el-form-item
                label="现汇税率(%)"
                prop="taxRate">
                <otpAdvance
                    :mValue="model.taxRate.toString()"
                    :prop="'taxRate'"
                    @getAdvanceValue="getTaxRateValue"
                    :params="taxRateLists">
                </otpAdvance>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button @click="beforeClose">取 消</el-button>
            <el-button type="primary" @click="saveBtn" :disabled="disabled">保 存</el-button>
        </span>
    </el-dialog>
</template>

<script>
import otpAdvance from '@/components/lots/otpAdvance';
import { updateOutLineContract } from '../../../api/dispatchOrder';

export default {
    components: { otpAdvance },
    props: {
        contractVisible: {
            type: Boolean,
            default: false
        },
        dataObj: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            model: {},
            disabled: false,
            rules: {
                transportationCost: [
                    {
                        required: true,
                        message: '运输成本不能为空',
                        trigger: 'blur'
                    },
                    {
                        pattern: /^(([1-9][0-9]{0,4})([.][0-9]{0,2})?|100000|100000.0|100000.00|!0.0|!0.00|!0)$/,
                        message:
                    '仅可输入数字，不能为0，支持小数点后2位；包含小数点共9位',
                        trigger: 'blur'
                    }
                ],
                taxRate: [
                    {
                        required: true,
                        message: '税率不能为空',
                        trigger: 'blur'
                    }
                ]
            },
            taxRateLists: {
                'name': '请输入税率',
                'advanceLabel': '税率',
                'value': 'taxRate',
                'advanceConfig': [
                    { 'prop': 'percentageRateStr', 'value': '税率百分比' },
                    { 'prop': 'taxRateCode', 'value': '税率代码' }

                ],
                'tableConfig': [
                    { 'prop': 'percentageRate', 'value': '税率百分比' },
                    { 'prop': 'taxRateCode', 'value': '税率代码' }
                ],
                'advanceUrl': 'efTaxRate/popTaxRate/in',
                'cbParams': [
                    'percentageRate#taxRate'
                ]
            }
        };
    },
    methods: {
        saveBtn() {
            this.$refs.elForm.validate(valid => {
                if (valid) {
                    this.disabled = true;
                    this.model.dispatchStatus = this.model.originDispatchStatus;
                    updateOutLineContract(this.model).then(res => {
                        if (res) {
                            this.$emit('costApprove', this.model);
                            this.beforeClose();
                        }
                    }).finally(() => {
                        this.disabled = false;
                    });
                }
            });
        },
        // 现汇税率基础数据
        getTaxRateValue(data) {
            this.model.taxRate = data.taxRate;
        },
        beforeClose() {
            this.$emit('update:contractVisible', false);
        }
    },
    created() {
        this.model = Object.assign({ taxRate: '' }, this.dataObj);
    }
};
</script>

<style lang="less">

</style>